import { css, CSSObject } from '@emotion/react'
import useTimeout from 'beautiful-react-hooks/useTimeout'
import React from 'react'
import * as styles from './TransitionLoader.styles'
import Loader, { LoaderProps } from '.'

export type TransitionLoaderProps = LoaderProps & {
  loaderDelay?: number
  styleOverride?: CSSObject
}

export const TransitionLoader: React.FC<
  React.PropsWithChildren<TransitionLoaderProps>
> = ({ children, loaderDelay = 250, styleOverride, ...loaderProps }) => {
  // Prevent loader from displaying for x milliseconds
  // This helps with the loader "flashing" on the screen in cases
  // where the loading process finishes quickly
  const [blockLoader, setBlockLoader] = React.useState<boolean>(true)
  useTimeout(() => setBlockLoader(false), loaderDelay)

  if (blockLoader && !loaderProps.loaded) return null

  return (
    <div css={[styles.container(), styleOverride]}>
      {loaderProps.loaded ? (
        <div css={css(styles.childContainer())}>{children}</div>
      ) : (
        <div css={css(styles.loaderContainer())}>
          <Loader {...loaderProps} />
        </div>
      )}
    </div>
  )
}
